import { render, staticRenderFns } from "./text-image.vue?vue&type=template&id=4f40a3c0"
import script from "./text-image.vue?vue&type=script&lang=js"
export * from "./text-image.vue?vue&type=script&lang=js"
import style0 from "./text-image.less?vue&type=style&index=0&prod&lang=less&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports